const whAsset = (value) => {
  if (!value) return value;
  const clean = String(value).replace(/^\/?assets\/(site\/)?(products\/)?/, '');
  return (window.WILDHIKER_ASSET_MAP && window.WILDHIKER_ASSET_MAP[clean]) || value;
};

const wildhikerReviews = [
  {
    category: "Easy Setup",
    title: "Love it",
    body: "Easy to assemble, lightweight!",
    product: "RestAngle / WH01001-BLUE"
  },
  {
    category: "Comfort",
    title: "Comfortable and great value",
    body: "This was a surprisingly nice chair and is very comfortable. I find this particular chair is a good value and is very comfortable.",
    product: "HuggleMode / WH01002-GREEN"
  },
  {
    category: "Camping & Travel",
    title: "Perfect For Primitive Camping - Especially on a Motorcycle!",
    body: "This chair worked perfectly for my motorcycle camping trip. As you can imagine, on a bike, you have to pack light and small. Although it breaks down and is very compact, it setups up nicely and is plenty sturdy.",
    product: "StandardMode / WH02004-KHAKI"
  },
  {
    category: "Camping & Travel",
    title: "Great camping chair for around the fire",
    body: "I bought 2 and man are they great. Super light weight yet very durable. Assembly took a few minutes to figure out the first time but once you do it, its super simple and fast the next time.",
    product: "StandardMode / WH02004-GREEN"
  },
  {
    category: "Parks & Events",
    title: "Perfect chair to go!",
    body: "This compact chair is perfect for games, at the park, and outdoor concerts! Took me literally less than a minute to set up everything up and the high back feature is comfortable!",
    product: "RestAngle / WH01001-black"
  },
  {
    category: "Sturdy Feel",
    title: "FIRST REVIEW",
    body: "Easy to put together, comfortable, feels strong. Great Product!! I hope it last at least 2 years. I am a heavy user.",
    product: "RestAngle / WH01001-black"
  },
  {
    category: "Comfort",
    title: "Great",
    body: "What a great surprise! Chair is stable and comfortable",
    product: "HuggleMode / WH01002-BLACK"
  },
  {
    category: "Carry & Pack",
    title: "Well Made and Comfortable.",
    body: "This has head and neck support so it's great for stargazing too. It does magically sort itself out and go back into the bag. Weight was key too, as I walk to a nearby beach for sunsets and this chair is light.",
    product: "RestAngle / WH01001-BLUE"
  },
  {
    category: "Camping & Travel",
    title: "Size and convince",
    body: "Perfect for putting on your Motorcycle and going. Sets up quick and packs away small.",
    product: "SteadyMode / WH02001-BLACK"
  },
  {
    category: "Parks & Events",
    title: "A must for cheer competitions",
    body: "They’re super comfortable, sturdy and stable, easy to assemble and disassemble (under 2 minutes for both), and super lightweight. Best cheer investment yet. We get asked about them often.",
    product: "HuggleMode / WH01002-BLACK"
  },
  {
    category: "Comfort",
    title: "75 Degree Seat",
    body: "Love thus chair! I can’t sit very long in a regular 90* chair. This angle allows me to be comfortable and enjoy the moment.",
    product: "SteadyMode / WH02001BLUE"
  },
  {
    category: "Carry & Pack",
    title: "Fits on motorcycle.",
    body: "It arrived quickly. It packs up small so it fits on my motorcycle no problem, it's very comfortable. It's sturdy, but it does flex a little.",
    product: "RestAngle / WH01001-BLUE"
  },
  {
    category: "Easy Setup",
    title: "Easy to fold and unfold.",
    body: "Easy to set up, comfortable.",
    product: "RestAngle / WH01001-black"
  },
  {
    category: "Sturdy Feel",
    title: "Light, sturdy, easy to set up",
    body: "Great chair. Very sturdy, yet very light weight. I appreciate the included optional duck feet for sandy or wet surfaces.",
    product: "SteadyMode / WH02001BLUE"
  },
  {
    category: "Camping & Travel",
    title: "Great chair if you need to travel.",
    body: "I needed a chair I could pack in a suitcase to fly to my daughter's lacrosse tournament and this chair was perfect! It was easy to put together and comfortable to use for her games.",
    product: "RestAngle / WH01001-black"
  },
  {
    category: "Carry & Pack",
    title: "Small, compact, sturdy, easy to set up, fits in a suitcase",
    body: "These chairs are very nice. Easily packs in the supplied case and in my suitcase for travel.",
    product: "HuggleMode / WH01002-BLACK"
  },
  {
    category: "Parks & Events",
    title: "Convenient and comfortable",
    body: "We bought two of these chairs to take to a multi-day music festival. They helped up well and were comfortable when we needed a break from dancing. The small size is very convenient for carrying on public transportation to events.",
    product: "SteadyMode / WH02001-BLACK"
  },
  {
    category: "Easy Setup",
    title: "Good camping chair",
    body: "I’ve tried many camp chairs and this one by far was the easiest to assemble and disassemble. Very comfy too. Good quality materials.",
    product: "HuggleMode / WH01002-GREEN"
  }
];

const escapeHTML = (value) => String(value)
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;");

const truncateText = (text, max = 230) => {
  if (text.length <= max) return { short: text, truncated: false };
  const cut = text.slice(0, max).replace(/\s+\S*$/, "");
  return { short: `${cut}...`, truncated: true };
};

function initReviewCarousel() {
  const root = document.querySelector("[data-review-carousel]");
  if (!root) return;

  const track = root.querySelector("[data-review-track]");
  const dots = root.querySelector("[data-review-dots]");
  const status = root.querySelector("[data-review-status]");
  const prev = root.querySelector("[data-review-prev]");
  const next = root.querySelector("[data-review-next]");
  const chips = document.querySelectorAll("[data-filter]");
  let activeCategory = "All Reviews";
  let activeReviews = [...wildhikerReviews];
  let index = 0;

  const getStep = () => {
    const card = track.querySelector(".review-card");
    if (!card) return 0;
    const gap = parseFloat(getComputedStyle(track).gap || "0");
    return card.getBoundingClientRect().width + gap;
  };

  const getMaxIndex = () => {
    const step = getStep();
    if (!step) return 0;
    const viewport = root.querySelector(".review-viewport");
    const overflowWidth = Math.max(track.scrollWidth - viewport.clientWidth, 0);
    return Math.ceil(overflowWidth / step);
  };

  const syncDots = () => {
    const pageCount = getMaxIndex() + 1;
    const currentCount = dots.children.length;
    if (currentCount === pageCount) return;
    dots.innerHTML = Array.from({ length: pageCount }, (_, dotIndex) => (
      `<button type="button" aria-label="Go to review page ${dotIndex + 1}"></button>`
    )).join("");
  };

  const updatePosition = () => {
    syncDots();
    const maxIndex = getMaxIndex();
    index = Math.min(Math.max(index, 0), maxIndex);
    track.style.transform = `translateX(${-index * getStep()}px)`;
    dots.querySelectorAll("button").forEach((dot, dotIndex) => {
      dot.classList.toggle("active", dotIndex === index);
      dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
    });
  };

  const render = () => {
    activeReviews = activeCategory === "All Reviews"
      ? [...wildhikerReviews]
      : wildhikerReviews.filter((review) => review.category === activeCategory);
    index = 0;
    track.innerHTML = activeReviews.map((review) => {
      const body = truncateText(review.body);
      return `
        <article class="review-card">
          <div class="pixel-corners"></div>
          <div class="review-card-meta">
            <span>Verified Purchase</span>
            <span>${escapeHTML(review.category)}</span>
          </div>
          <h4>${escapeHTML(review.title)}</h4>
          <p data-short="${escapeHTML(body.short)}" data-full="${escapeHTML(review.body)}">${escapeHTML(body.short)}</p>
          ${body.truncated ? '<button class="read-more" type="button">Read more</button>' : ""}
          <small>${escapeHTML(review.product)}</small>
        </article>
      `;
    }).join("");
    dots.innerHTML = "";
    status.textContent = activeCategory === "All Reviews"
      ? "Verified Amazon customer words"
      : `${activeCategory} reviews from verified Amazon customers`;
    updatePosition();
  };

  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      activeCategory = chip.dataset.filter;
      chips.forEach((item) => {
        const active = item === chip;
        item.classList.toggle("active", active);
        item.setAttribute("aria-pressed", active ? "true" : "false");
      });
      render();
    });
  });

  prev.addEventListener("click", () => {
    const maxIndex = getMaxIndex();
    index = index <= 0 ? maxIndex : index - 1;
    updatePosition();
  });

  next.addEventListener("click", () => {
    const maxIndex = getMaxIndex();
    index = index >= maxIndex ? 0 : index + 1;
    updatePosition();
  });

  dots.addEventListener("click", (event) => {
    const dot = event.target.closest("button");
    if (!dot) return;
    index = [...dots.children].indexOf(dot);
    updatePosition();
  });

  track.addEventListener("click", (event) => {
    const button = event.target.closest(".read-more");
    if (!button) return;
    const body = button.previousElementSibling;
    const expanded = button.dataset.expanded === "true";
    body.textContent = expanded ? body.dataset.short : body.dataset.full;
    button.textContent = expanded ? "Read more" : "Show less";
    button.dataset.expanded = String(!expanded);
  });

  window.addEventListener("resize", updatePosition);
  render();
}

function initProofType() {
  const lines = document.querySelectorAll("[data-type-text]");
  if (!lines.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  lines.forEach((line, lineIndex) => {
    const text = line.dataset.typeText;
    line.textContent = "";
    line.classList.add("is-typing");
    let i = 0;
    window.setTimeout(() => {
      const timer = window.setInterval(() => {
        line.textContent = text.slice(0, i);
        i += 2;
        if (i > text.length) {
          line.textContent = text;
          line.classList.remove("is-typing");
          window.clearInterval(timer);
        }
      }, 24);
    }, lineIndex * 220);
  });
}

function initProductSwatches() {
  document.querySelectorAll("[data-product-card]").forEach((card) => {
    const image = card.querySelector("[data-target-image]");
    const fallback = card.querySelector("[data-image-fallback]");
    const colorLabel = card.querySelector("[data-current-color]");
    const swatches = card.querySelectorAll("[data-swatch]");

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        const colorName = swatch.dataset.colorName;
        const imagePath = swatch.dataset.image;
        const useFallback = swatch.dataset.fallback === "true";

        swatches.forEach((item) => {
          const active = item === swatch;
          item.classList.toggle("active", active);
          item.setAttribute("aria-pressed", active ? "true" : "false");
        });

        if (colorLabel) colorLabel.textContent = `Color: ${colorName}`;

        if (image && fallback) {
          image.alt = `${card.querySelector("h3")?.textContent || "Wildhiker chair"} in ${colorName}`;
          image.src = whAsset(imagePath);
          image.hidden = useFallback;
          fallback.hidden = !useFallback;
          fallback.querySelector("span").textContent = `${colorName} image pending`;
        }
      });
    });
  });
}

function initComfortQuiz() {
  const root = document.querySelector("[data-comfort-quiz]");
  if (!root) return;

  const products = {
    HuggleMode: {
      title: "HuggleMode",
      role: "Flagship comfort chair",
      best: "RV trips, family camping, and longer outdoor sessions.",
      copy: "Best for users who want the most comfortable Wildhiker chair for longer outdoor time, relaxed weekends, and premium sitting comfort.",
      image: "assets/products/hugglemode-black.png",
      imageAlt: "HuggleMode chair",
      url: "/products/hugglemode"
    },
    RestAngle: {
      title: "RestAngle",
      role: "Core high-back comfort chair",
      best: "Campfires, RV stops, and longer sits.",
      copy: "Best for relaxed high-back comfort when you want to lean back, stay longer, and enjoy slower outdoor moments.",
      image: "assets/products/restangle-black.png",
      imageAlt: "RestAngle chair",
      url: "/products/restangle"
    },
        "RestAngle Pro": {
      title: "RestAngle Pro",
      role: "Soft-ground high-back upgrade",
      best: "Backyard, RV trips, beach days, grass, and softer outdoor ground.",
      copy: "Best if you want fixed deep-recline comfort with wider arm pads, large foot pads, and an upgraded side pocket for softer outdoor setups.",
      image: "assets/products/restangle-pro-black.png",
      imageAlt: "RestAngle Pro chair",
      url: "/products/restangle-pro"
    },
    StandardMode: {
      title: "StandardMode",
      role: "Everyday outdoor chair",
      best: "Parks, events, sidelines, and everyday outdoor use.",
      copy: "Best for simple, lightweight outdoor seating for parks, events, sidelines, and quick weekend plans.",
      image: "assets/products/standardmode-black.png",
      imageAlt: "StandardMode chair",
      url: "/products/standardmode"
    },
    SteadyMode: {
      title: "SteadyMode",
      role: "Soft-ground stability chair",
      best: "Beach days, grass, campgrounds, and mixed outdoor ground.",
      copy: "Best for users who want a standard-height chair with better stability for soft ground, beach days, grass, and campgrounds.",
      image: "assets/products/steadymode-black.png",
      imageAlt: "SteadyMode chair",
      url: "/products/steadymode"
    }
  };

  const questions = [
    {
      text: "Where will you use it most?",
      options: [
        { key: "A", text: "RV trips, campfires, and longer sits", scores: { RestAngle: 3, "RestAngle Pro": 2, HuggleMode: 2 } },
        { key: "B", text: "Beach, grass, soft ground, and campgrounds", scores: { "RestAngle Pro": 4, SteadyMode: 3 } },
        { key: "C", text: "Parks, events, sidelines, and everyday outdoor use", scores: { StandardMode: 3, SteadyMode: 1 } },
        { key: "D", text: "Motorcycle trips, hiking, and compact travel", scores: { StandardMode: 3, RestAngle: 1 } }
      ]
    },
    {
      text: "What matters most to you?",
      options: [
        { key: "A", text: "Maximum comfort", scores: { HuggleMode: 4, "RestAngle Pro": 2, RestAngle: 1 } },
        { key: "B", text: "Better stability on soft ground", scores: { "RestAngle Pro": 4, SteadyMode: 3 } },
        { key: "C", text: "Lightweight and easy carry", scores: { StandardMode: 4 } },
        { key: "D", text: "Balanced everyday use", scores: { StandardMode: 2, SteadyMode: 1, RestAngle: 1 } }
      ]
    },
    {
      text: "How long do you usually sit?",
      options: [
        { key: "A", text: "A few hours around camp or RV", scores: { "RestAngle Pro": 3, HuggleMode: 3, RestAngle: 2 } },
        { key: "B", text: "Short breaks during trips", scores: { StandardMode: 2, SteadyMode: 1 } },
        { key: "C", text: "Long games, concerts, or events", scores: { StandardMode: 2, HuggleMode: 2 } },
        { key: "D", text: "Depends on the day", scores: { StandardMode: 1, RestAngle: 1, SteadyMode: 1 } }
      ]
    },
    {
      text: "What kind of sitting feel do you prefer?",
      options: [
        { key: "A", text: "High-back relaxed comfort", scores: { "RestAngle Pro": 4, RestAngle: 3 } },
        { key: "B", text: "Supportive and more enclosed", scores: { HuggleMode: 4 } },
        { key: "C", text: "Standard-height everyday comfort", scores: { StandardMode: 4 } },
        { key: "D", text: "Stable and practical for mixed ground", scores: { "RestAngle Pro": 4, SteadyMode: 3 } }
      ]
    }
  ];

  const state = {
    step: 0,
    answers: Array(questions.length).fill(null),
    complete: false
  };

  const questionEl = root.querySelector("[data-quiz-question]");
  const optionsEl = root.querySelector("[data-quiz-options]");
  const progressEl = root.querySelector("[data-quiz-progress]");
  const progressBar = root.querySelector("[data-quiz-progress-bar]");
  const backBtn = root.querySelector("[data-quiz-back]");
  const nextBtn = root.querySelector("[data-quiz-next]");
  const resultKicker = root.querySelector(".result-kicker");
  const resultTitle = root.querySelector("[data-result-title]");
  const resultRole = root.querySelector("[data-result-role]");
  const resultBest = root.querySelector("[data-result-best]");
  const resultCopy = root.querySelector("[data-result-copy]");
  const resultImage = root.querySelector("[data-result-image]");
  const resultPlaceholder = root.querySelector("[data-result-placeholder]");
  const resultView = root.querySelector("[data-result-view]");

  const selectedOptions = () => state.answers.filter(Boolean);

  const scoreProducts = () => {
    const scores = Object.keys(products).reduce((acc, product) => ({ ...acc, [product]: 0 }), {});
    selectedOptions().forEach((option) => {
      Object.entries(option.scores).forEach(([product, points]) => {
        scores[product] += points;
      });
    });
    return scores;
  };

  const tiePriority = () => {
    const answerKeys = state.answers.map((answer) => answer?.key || "");
    if (answerKeys[1] === "A" || answerKeys[3] === "B") return ["HuggleMode"];
    if (answerKeys[3] === "D") return ["RestAngle Pro", "SteadyMode"];
    if (answerKeys[0] === "B" || answerKeys[1] === "B") return ["RestAngle Pro", "SteadyMode"];
    if (answerKeys[0] === "C" || answerKeys[1] === "C") return ["StandardMode"];
    if (answerKeys[0] === "A" || answerKeys[2] === "A" || answerKeys[3] === "A") return ["RestAngle Pro", "RestAngle", "HuggleMode"];
    return ["RestAngle Pro", "RestAngle", "HuggleMode", "SteadyMode", "StandardMode"];
  };

  const getRecommendation = () => {
    if (!selectedOptions().length) return products.HuggleMode;
    const scores = scoreProducts();
    const topScore = Math.max(...Object.values(scores));
    const tied = Object.keys(scores).filter((product) => scores[product] === topScore);
    const preferred = tiePriority().find((product) => tied.includes(product)) || tied[0];
    return products[preferred];
  };

  const updateResult = () => {
    const result = getRecommendation();
    resultTitle.textContent = result.title;
    resultRole.textContent = result.role;
    resultBest.textContent = result.best;
    resultCopy.textContent = result.copy;
    if (resultImage && resultPlaceholder) {
      resultImage.src = whAsset(result.image);
      resultImage.alt = result.imageAlt;
      resultImage.hidden = false;
      resultPlaceholder.hidden = true;
      resultPlaceholder.textContent = `${result.title} product image`;
    }
    resultKicker.textContent = state.complete
      ? "Your recommended match is ready."
      : selectedOptions().length
        ? "Live recommendation based on your answers."
        : "Start the quiz to refine this recommendation.";
    if (resultView) resultView.href = result.url;
  };

  const render = () => {
    const question = questions[state.step];
    const selected = state.answers[state.step];
    const progress = ((state.step + 1) / questions.length) * 100;

    progressEl.textContent = `Question ${state.step + 1} of ${questions.length}`;
    progressBar.style.setProperty("--quiz-progress", `${progress}%`);
    questionEl.textContent = question.text;
    optionsEl.innerHTML = question.options.map((option) => `
      <button class="quiz-option${selected?.key === option.key ? " is-selected" : ""}" type="button" data-option-key="${option.key}">
        <span class="option-letter">${option.key}</span>
        <span class="option-text">${escapeHTML(option.text)}</span>
      </button>
    `).join("");

    backBtn.disabled = state.step === 0 && !state.complete;
    backBtn.style.opacity = backBtn.disabled ? ".45" : "1";
    nextBtn.textContent = state.step === questions.length - 1 ? "See Result" : "Next";
    nextBtn.disabled = !selected;
    nextBtn.style.opacity = nextBtn.disabled ? ".45" : "1";
    updateResult();
  };

  optionsEl.addEventListener("click", (event) => {
    const button = event.target.closest("[data-option-key]");
    if (!button) return;
    const question = questions[state.step];
    state.answers[state.step] = question.options.find((option) => option.key === button.dataset.optionKey);
    state.complete = false;
    render();
  });

  backBtn.addEventListener("click", () => {
    if (state.complete) state.complete = false;
    if (state.step > 0) state.step -= 1;
    render();
  });

  nextBtn.addEventListener("click", () => {
    if (!state.answers[state.step]) return;
    if (state.step < questions.length - 1) {
      state.step += 1;
      render();
      return;
    }
    state.complete = true;
    updateResult();
  });

  render();
}

function initMobileMenu() {
  const header = document.querySelector("[data-mobile-header]");
  if (!header) return;

  const toggle = header.querySelector("[data-mobile-menu-toggle]");
  const menu = header.querySelector("[data-mobile-menu]");
  if (!toggle || !menu) return;

  const setOpen = (open) => {
    header.classList.toggle("is-menu-open", open);
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    menu.hidden = !open;
    document.body.classList.toggle("mobile-menu-open", open);
  };

  toggle.addEventListener("click", () => {
    setOpen(menu.hidden);
  });

  menu.addEventListener("click", (event) => {
    if (event.target.closest("a")) setOpen(false);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setOpen(false);
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 860) setOpen(false);
  });
}

function initFooterAccordion() {
  const root = document.querySelector("[data-footer-accordion]");
  if (!root) return;

  const media = window.matchMedia("(max-width: 749px)");
  const syncPanels = () => {
    root.querySelectorAll(".footer-link-group").forEach((group) => {
      const button = group.querySelector("h4 button");
      const panel = group.querySelector(".footer-link-panel");
      if (!button || !panel) return;
      if (media.matches) {
        const open = group.classList.contains("is-open");
        panel.hidden = !open;
        button.setAttribute("aria-expanded", String(open));
      } else {
        panel.hidden = false;
        group.classList.remove("is-open");
        button.setAttribute("aria-expanded", "false");
      }
    });
  };

  root.querySelectorAll(".footer-link-group").forEach((group) => {
    const button = group.querySelector("h4 button");
    const panel = group.querySelector(".footer-link-panel");
    if (!button || !panel) return;

    button.addEventListener("click", () => {
      if (!media.matches) return;
      const open = !group.classList.contains("is-open");
      group.classList.toggle("is-open", open);
      button.setAttribute("aria-expanded", String(open));
      panel.hidden = !open;
    });
  });

  syncPanels();
  media.addEventListener("change", syncPanels);
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileMenu();
  initFooterAccordion();
  initReviewCarousel();
  initProofType();
  initProductSwatches();
  initComfortQuiz();
});

(function () {
  const modal = document.querySelector("[data-video-modal]");
  if (!modal) return;

  const frame = modal.querySelector("[data-video-modal-frame]");
  const closeButtons = modal.querySelectorAll("[data-video-modal-close]");

  function getYoutubeEmbed(url) {
    try {
      const parsed = new URL(url, window.location.href);
      let id = "";

      if (parsed.hostname.includes("youtu.be")) {
        id = parsed.pathname.split("/").filter(Boolean)[0];
      } else if (parsed.hostname.includes("youtube.com")) {
        if (parsed.pathname.includes("/embed/")) {
          id = parsed.pathname.split("/embed/")[1].split("/")[0];
        } else {
          id = parsed.searchParams.get("v");
        }
      }

      return id ? "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0&modestbranding=1&playsinline=1" : url;
    } catch (error) {
      return url;
    }
  }

  function isYoutube(url) {
    return /youtu\.be|youtube\.com/.test(url || "");
  }

  function openVideo(url) {
    if (!url || !frame) return;

    if (isYoutube(url)) {
      frame.innerHTML = '<iframe src="' + getYoutubeEmbed(url) + '" title="Wildhiker video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    } else {
      frame.innerHTML = '<video src="' + url + '" controls autoplay playsinline></video>';
    }

    modal.hidden = false;
    document.body.classList.add("video-modal-open-v1");
  }

  function closeVideo() {
    modal.hidden = true;
    document.body.classList.remove("video-modal-open-v1");
    if (frame) frame.innerHTML = "";
  }

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest("[data-video-trigger]");
    if (!trigger) return;

    event.preventDefault();
    openVideo(trigger.getAttribute("data-video-url") || trigger.getAttribute("href"));
  });

  closeButtons.forEach(function (button) {
    button.addEventListener("click", closeVideo);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !modal.hidden) closeVideo();
  });
})();